<script>
import ProjectMomService from "@/services/ProjectMomService";
import Cloner from "@/libraries/Cloner";
import dayjs from "dayjs";

export default {
    props: {
        mom: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            saving: false,
            errors: {},
            entity: {
                id: null,
                next_date: null,
                next_location: null
            }
        };
    },
    created() {
        this.entity = Cloner.pickClone(this.mom, [
            "id",
            "next_date",
            "next_location"
        ]);
        if (this.entity.next_date) {
            this.entity.next_date = dayjs(this.entity.next_date).format(
                "YYYY-MM-DDTHH:mm"
            );
        }
    },
    mounted() {
        this.$nextTick(() => {
            const input = this.$refs.firstInput?.$el.querySelector("input");
            if (input) input.focus();
        });
    },
    methods: {
        async saveForm() {
            try {
                this.saving = true;
                this.errors = {};
                await ProjectMomService.PUT(this.entity);
                this.$emit("close-reload");
            } catch (e) {
                this.errors = e.response.data.errors;
            }
            this.saving = false;
        }
    }
};
</script>

<template>
    <modal :show="true" @close="$emit('close')" class="budget-modal">
        <template slot="header">{{
            $t("moms.next_meeting_modal_title")
        }}</template>

        <template slot="default">
            <FormulateForm v-model="entity" @submit="saveForm" :errors="errors">
                <div class="row">
                    <FormulateErrors />
                    <div class="col-12">
                        <FormulateInput
                            type="datetime-local"
                            ref="firstInput"
                            name="next_date"
                            :label="$t('moms.next_meeting_field_date')"
                        />
                    </div>
                    <div class="col-12">
                        <FormulateInput
                            type="textarea"
                            name="next_location"
                            :label="$t('moms.next_meeting_field_location')"
                            rows="3"
                        />
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col text-right">
                        <base-button
                            type="secondary"
                            :outline="true"
                            @click="$emit('close')"
                            >{{ $t("cancel") }}</base-button
                        >
                        <base-button
                            type="primary"
                            :loading="saving"
                            native-type="submit"
                            >{{ $t("save") }}</base-button
                        >
                    </div>
                </div>
            </FormulateForm>
        </template>
    </modal>
</template>
